import { CookieOptions } from 'ngx-cookie';
import { environment } from 'environments/environment';

export const defaultCookieParams: CookieOptions = {
    path: '/',
    domain: environment.COOKIE_DOMAIN,
    secure: environment.production,
    sameSite: false
};
export const defaultCookieParamsLogin: CookieOptions = {
    path: '/',
    domain: environment.COOKIE_DOMAIN,
    secure: environment.production,
    sameSite: !!environment.production ? 'none' : false
};
